// @flow

import React, { type Node, useEffect, useState } from 'react';
import { zeroPad } from '@tectonics/hooks/use-legacy-countdown';
import { usePayment } from '../context';
import yapeAvatarSrc from '../yape-avatar.svg';
import {
  Container,
  Content,
  Avatar,
  Title,
  Subtitle,
  RemainingTime,
  ClockIcon,
  RemainingTimeText,
  Steps,
  StepCard,
  StepNumber,
  StepText,
} from './waiting-approval-screen.styles';

function getRemainingSeconds(deadline: ?number): number {
  if (deadline == null) return 0;
  return Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
}

export function WaitingApprovalScreen(): Node {
  const { data } = usePayment();
  const [remainingSeconds, setRemainingSeconds] = useState(() =>
    getRemainingSeconds(data.waitingDeadline),
  );

  useEffect(() => {
    const updateRemainingTime = () => {
      setRemainingSeconds(getRemainingSeconds(data.waitingDeadline));
    };

    updateRemainingTime();
    const interval = setInterval(updateRemainingTime, 1000);

    return () => clearInterval(interval);
  }, [data.waitingDeadline]);

  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;

  return (
    <Container>
      <Content>
        <Avatar src={yapeAvatarSrc} alt="Yape" />
        <Title>Sigue estos pasos</Title>
        <Subtitle>Tiempo restante para aprobar la compra.</Subtitle>
        <RemainingTime>
          <ClockIcon viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <circle cx="10" cy="10" r="7.25" stroke="currentColor" strokeWidth="1.5" />
            <path
              d="M10 6.5V10.25L12.25 11.5"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </ClockIcon>
          <RemainingTimeText>
            {zeroPad(minutes)}:{zeroPad(seconds)}
          </RemainingTimeText>
        </RemainingTime>

        <Steps>
          <StepCard>
            <StepNumber>1</StepNumber>
            <StepText>
              Abre la app de Yape en tu teléfono y busca la opción de aprobar
              compras en la pantalla de inicio
            </StepText>
          </StepCard>
          <StepCard>
            <StepNumber>2</StepNumber>
            <StepText>
              En &quot;Tus solicitudes&quot; encontrarás la aprobación pendiente
            </StepText>
          </StepCard>
        </Steps>
      </Content>
    </Container>
  );
}
